import React from "react";
import { MANUAL_CAR_IMAGES, AUTOMATIC_CAR_IMAGES } from "../lib/assets";
import { useLang } from "../context/LangContext";

const Gallery = () => {
  const { t } = useLang();
  const images = [
    { src: MANUAL_CAR_IMAGES[0], label: "Suzuki S-Cross 2024", tag: "MANUALĂ", span: "lg:col-span-2 lg:row-span-2" },
    { src: MANUAL_CAR_IMAGES[1], label: "Suzuki S-Cross 2024", tag: "MANUALĂ", span: "" },
    { src: AUTOMATIC_CAR_IMAGES[1], label: "Toyota Corolla Hybrid 2020", tag: "AUTOMATĂ", span: "" },
    { src: MANUAL_CAR_IMAGES[2], label: "Suzuki S-Cross 2024", tag: "MANUALĂ", span: "" },
    { src: AUTOMATIC_CAR_IMAGES[2], label: "Toyota Corolla Hybrid 2020", tag: "AUTOMATĂ", span: "" },
    { src: MANUAL_CAR_IMAGES[3], label: "Suzuki S-Cross 2024", tag: "MANUALĂ", span: "" },
    { src: AUTOMATIC_CAR_IMAGES[3], label: "Toyota Corolla Hybrid 2020", tag: "AUTOMATĂ", span: "" },
    { src: MANUAL_CAR_IMAGES[4], label: "Suzuki S-Cross 2024", tag: "MANUALĂ", span: "lg:col-span-2" },
  ];

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] font-bold text-brand-orange mb-4">
            {t.gallery.eyebrow}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-navy leading-tight tracking-tight">
            {t.gallery.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-brand-muted leading-relaxed">
            {t.gallery.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 auto-rows-[180px] sm:auto-rows-[220px]">
          {images.map((img, i) => (
            <div
              key={img.src}
              data-testid={`gallery-item-${i}`}
              className={`relative rounded-2xl overflow-hidden group ${img.span}`}
            >
              <img
                src={img.src}
                alt={`${img.label} ${img.tag}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy-deep/70 via-transparent to-transparent" />
              <div className="absolute bottom-3 right-3 flex">
                <span className={`px-3 py-1.5 rounded-full text-[10px] uppercase tracking-wider font-bold text-white shadow-lg ${
                  img.tag === "MANUALĂ" ? "bg-brand-orange" : "bg-brand-navy"
                }`}>
                  {img.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
